export default [
    {
        path: 'relatorio-inconsistencia',
        component: () => import(/* webpackChunkName: 'apac-relatorio-inconsistencia' */ '@/views/apac/relatorio-inconsistencia/Index'),
        redirect: 'relatorio-inconsistencia/index',
        children: [
            {
                name: 'apac-relatorio-inconsistencia-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'apac-relatorio-inconsistencia' */ '@/views/apac/relatorio-inconsistencia/List.vue'),
            },
        ],
    },
]